import { useEffect, useRef } from "react";

export const useReveal = (options = {}) => {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                        obs.unobserve(entry.target);
                    }
                });
            },
            { threshold: options.threshold ?? 0.15, rootMargin: options.rootMargin ?? "0px 0px -50px 0px" }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, [options.threshold, options.rootMargin]);
    return ref;
};
